// Делит сумму на равные доли с округлением вниз до цента: сумма долей
// не превышает исходную. Считаем в целых центах, чтобы не ловить
// ошибки плавающей точки (0.29 * 100 = 28.999…).
export const splitAmountFloor = (amount: number, parts: number): string => {
  if (!parts || amount <= 0) return "0.00";
  const cents = Math.round(amount * 100);
  return (Math.floor(cents / parts) / 100).toFixed(2);
};
